import { isValidRelativeRoute } from './navigation';

/**
 * Validates if a route is safe to navigate to
 * @param route - The route to validate
 * @returns Object with validation result and error message if any
 */
export const validateRoute = (
  route: string | null
): { isValid: boolean; error?: string } => {
  if (!route) {
    return { isValid: false, error: 'Route is null or undefined' };
  }
  if (route.trim() === '') {
    return { isValid: false, error: 'Route cannot be empty' };
  }

  // Check if route is a valid relative route
  if (!isValidRelativeRoute(route)) {
    return { isValid: false, error: 'Route is not a valid relative route' };
  }

  // Check for potentially dangerous patterns
  const dangerousPatterns = [
    /\.\./, // Directory traversal
    /javascript:/i, // JavaScript protocol
    /data:/i, // Data protocol
    /vbscript:/i, // VBScript protocol
  ];

  for (const pattern of dangerousPatterns) {
    if (pattern.test(route)) {
      return {
        isValid: false,
        error: 'Route contains potentially dangerous patterns',
      };
    }
  }

  return { isValid: true };
};
